<p-button
    icon="pi pi-envelope"
    [label]="actionKey() | translate"
    [outlined]="true"
    [severity]="user().activated ? 'secondary' : 'warn'"
    [loading]="sending()"
    [disabled]="cooldown()"
    [attr.aria-expanded]="popoverVisible()"
    aria-haspopup="dialog"
    [attr.data-test]="testId()"
    (onClick)="onToggle($event, popover)"
/>

<p-popover
    #popover
    styleClass="popover-left"
    [style]="popoverStyle()"
    [baseZIndex]="baseZIndex"
    [ariaLabel]="actionKey() | translate"
    (onShow)="popoverVisible.set(true)"
    (onHide)="popoverVisible.set(false)"
>
    <div class="confirm">
        <h3>{{ actionKey() | translate }}</h3>
        <p>
            {{ 'users.access.confirm.question' | translate }}
            <strong>{{ user().email }}</strong
            >?
        </p>
        @if (emailEdited()) {
            <p-message severity="warn" size="small" [attr.data-test]="testId() + '-unsaved-email'">
                {{ 'users.access.confirm.unsavedEmail' | translate }}
            </p-message>
        }
        <p class="description">{{ descriptionKey() | translate }}</p>
        <div class="actions">
            <p-button
                [label]="'users.access.confirm.reject' | translate"
                severity="secondary"
                [outlined]="true"
                size="small"
                [attr.data-test]="testId() + '-cancel'"
                (onClick)="popover.hide()"
            />
            <p-button [label]="'users.access.confirm.accept' | translate" size="small" [attr.data-test]="testId() + '-submit'" (onClick)="onConfirm(popover)" />
        </div>
    </div>
</p-popover>
